var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "outlined-except-top-left", attrs: { flat: "" } },
    [
      _c(
        "v-container",
        {
          staticClass: "content-container",
          class: !_vm.isMobilePort ? "px-5" : "",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "8" } },
                [
                  _c("h2", { staticClass: "text-h4 font-weight-medium" }, [
                    _vm._v("Notes and Bookmarks"),
                  ]),
                  _vm._v(" "),
                  _c("share-feedback"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex",
                  class: {
                    "d-flex justify-end": !_vm.isMobilePort,
                  },
                  attrs: { cols: "12", md: "4" },
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-2",
                                      attrs: { outlined: "" },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n                            Actions\n                            "
                                  ),
                                  _c("v-icon", { staticClass: "ml-1" }, [
                                    _vm._v("mdi-chevron-down"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            {
                              attrs: {
                                href: _vm.getRoute("dashboard_my_tags"),
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                { staticClass: "mr-3" },
                                [_c("v-icon", [_vm._v("mdi-label-outline")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-title", [_vm._v("Manage Tags")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.isPrintLoading },
                      on: { click: _vm.onPrintClick },
                    },
                    [
                      _vm._v(
                        "\n                Print (" +
                          _vm._s(_vm.sectionsCount) +
                          " sections)\n              "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }